import { faEnvelopeOpenText as fadEnvelopeOpenText } from "@awesome.me/kit-3777c2145e/icons/duotone/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import compact from "lodash/compact";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";
import { Config } from "@/app/config";
import { AbstractStep } from "@/component/assets/AbstractLeadForm/Steps/AbstractStep";

export interface StepFields {
	loanGoal: string;
	married: boolean;
	numberOfChildren: number;
	numberOfChildrenCommitment: number;
	taxDept: boolean;
	socialInsuranceSinceId: number;
}

export class SuccessSubscription extends AbstractStep<StepFields> {
	protected renderContent(): ReactNode {
		return (
			<>
				<Card.Header>
					<Card.Title>Sikeresen feliratkoztál hírlevelünkre!</Card.Title>
				</Card.Header>
				<Card.Body className="d-flex flex-column">
					<div className="display-1 text-center mt-auto">
						<FontAwesomeIcon icon={fadEnvelopeOpenText} />
					</div>
					<div className="h4 mb-auto text-center">Köszönjük hogy feliratkoztál hírlevelünkre!</div>
					<div className="text-center">
						Amennyiben további kérdésed, észrevételed merülne fel, lépj velünk kapcsolatba a{" "}
						<a className="text-reset text-underlined" href={`mailto:${Config.getContactEmail()}`}>
							{Config.getContactEmail()}
						</a>{" "}
						e-mail címen keresztül!
					</div>
				</Card.Body>
			</>
		);
	}

	protected getClassName(): string {
		return compact([super.getClassName(), "bg-success"]).join(" ");
	}

	protected getComponentName(): string {
		return "SuccessSubscription";
	}
}
